import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import { Breakpoint, BreakpointProvider } from 'react-socks'
import { IfHydrated } from '../../../libs/next/hydratation'
import style from './Hidden.module.sass'

export type HiddenProps = {
	breakpoint: 'mobileUp' | 'mobileDown' | 'desktopUp' | 'desktopDown'
	marginAuto?: 'top' | 'bottom'
	children: React.ReactNode
	isGridVisible?: boolean
}

export const Hidden: FunctionComponent<HiddenProps> = ({ children, breakpoint, marginAuto, isGridVisible }) => {
	const content =
		Boolean(marginAuto) || isGridVisible ? (
			<div className={clsx(isGridVisible && style.wrapperInGrid, style[`margin_${marginAuto}`])}>{children}</div>
		) : (
			children
		)

	return (
		<IfHydrated
			yes={() => (
				<BreakpointProvider>
					{breakpoint === 'mobileUp' && (
						<Breakpoint xs only>
							{content}
						</Breakpoint>
					)}
					{breakpoint === 'desktopUp' && (
						<Breakpoint s down>
							{content}
						</Breakpoint>
					)}
					{breakpoint === 'mobileDown' && (
						<Breakpoint s up>
							{content}
						</Breakpoint>
					)}
					{breakpoint === 'desktopDown' && (
						<Breakpoint m only>
							{content}
						</Breakpoint>
					)}
				</BreakpointProvider>
			)}
		/>
	)
}
